


















































































































































































































































import { Vue, Component } from 'vue-property-decorator';
import { default as DataPanel } from '@/components/DataPanel.vue';
import { default as SearchPanel } from '@/components/SearchPanel.vue';
import { PaginationPanel, DraggerImg } from '@/components';
import collapse from '../../utils/collapse.js';
import ListFilterPanel from '@/components/ListFilterPanel.vue';
import { enums } from '@/common/enums';
import { formRules } from '@/common/util/validator';
import AddressSelect from '@/components/AddressSelect.vue';
import { CustomerBase,Carrier } from '@/http';
import { type } from '@/http/interface';
import publicFunc from '../../common/util/publicFunc';
export interface Pagination {
    skip: number;
    count: number;
    currentPage: number;
}
@Component({
    components: {
        DataPanel,
        SearchPanel,
        PaginationPanel,
        DraggerImg,
        collapse,
        ListFilterPanel,
        AddressSelect,
    },
})
export default class ShipManagement extends Vue {

    public publicFunc = publicFunc;

    public searchValue: CustomerBase.GetCustomerBaseListPayload = {
        customerBaseName: '',
        customerBaseContactName:'',
        isEnabled: null,
        startTime: '',
        endTime: '',
        asc: true,
        orderBy: ''
    };
    public timeList = [];

    public title: string = '新增客户/基地';

    public dialogVisible: boolean = false;

    public formRules = formRules;

    public shipStateType = enums.shipStateType;

    public isActive: boolean = false;

    public loading: boolean = false;

    public rePagin: boolean = false;

    public total: number = 0;

    public tableData:any = [];

    public formData: CustomerBase.AddOrEdiCustomerBaseVM = {
        customerBaseName: '',
        customerBaseType: null,
        customerBaseCode: '',
        customerBaseContactName: '',
        customerBaseContactPhone: '',
        province: '',
        city: '',
        county: '',
        detail: '',
        carrierRelationsList: [],
        carrierRelations: [],
        rainClothAmount: '',
        isEnabled: false,
        remark: '',
    };

    public carrierList: any = [];

    public selectReset = false;

    public $refs!: {
        pagination: HTMLFormElement;
        multipleTable: HTMLFormElement;
        draggerImg: HTMLFormElement;
        formData: HTMLFormElement;
        address: HTMLFormElement;
    };

    public created() {
        this.selectReset = true;
    }
    public mounted() {
        if (sessionStorage.getItem('ShipManagement_searchValue')) {
            this.searchValue = JSON.parse(sessionStorage.getItem('ShipManagement_searchValue'));
            this.timeList = [this.searchValue.startTime, this.searchValue.endTime];
            this.searchPagin = sessionStorage.getItem('ShipManagement_page')
                ? JSON.parse(sessionStorage.getItem('ShipManagement_page'))
                : this.searchPagin;

            this.loadData();
        } else {
            this.searchPagin = sessionStorage.getItem('ShipManagement_page')
                ? JSON.parse(sessionStorage.getItem('ShipManagement_page'))
                : this.searchPagin;

            this.loadData();
        }
    }
    public colData = JSON.parse(localStorage.getItem('ShipManagement'))
        ? JSON.parse(localStorage.getItem('ShipManagement'))
        : [
              { title: '客户/基地编码', isShow: true, disabled: false },
              { title: '客户/基地名称', isShow: true, disabled: false },
              { title: '客户/基地分类', isShow: true, disabled: false },
              { title: '联系人', isShow: true, disabled: false },
              { title: '联系人手机号', isShow: true, disabled: false },
              { title: '地址', isShow: true, disabled: false },
              { title: '下属车队', isShow: true, disabled: false },
              { title: '雨布费用', isShow: true, disabled: false },
              { title: '状态', isShow: true, disabled: false },
              { title: '创建人', isShow: true, disabled: false },
              { title: '创建时间', isShow: true, disabled: false },
          ];
    public searchFunc() {
        this.loadData();
        sessionStorage.setItem('ShipManagement_searchValue', JSON.stringify(this.searchValue));
    }

    public searchPagin: Pagination = {
        skip: 0,
        count: 10,
        currentPage: 1,
    };
    public async onPaginationChange(pagin: Pagination) {
        this.searchPagin = pagin;
        sessionStorage.setItem('ShipManagement_page', JSON.stringify(pagin));
        this.loadData();
    }

    public handleCheckedChange() {
        let newDate = this.colData.filter((item) => item.isShow == false);
        if (this.colData.length - newDate.length == 3) {
            this.$message.warning('至少选择3个');
            this.colData.forEach((item) => {
                if (item.isShow) {
                    item.disabled = true;
                }
            });
        } else {
            this.colData.forEach((item) => {
                item.disabled = false;
            });
        }
        localStorage.setItem('ShipManagement', JSON.stringify(this.colData));
    }

    public async loadData() {
        this.loading = true;
        try {
          let skip = this.searchPagin.skip; 
          let res = await CustomerBase.GetList({
                ...this.searchValue,
                skip: skip,
                count: this.searchPagin.count
            });
            this.tableData = res.data;
            this.$refs.pagination.setPage(this.searchPagin.currentPage);
            this.tableData.map((item, index) => {
                item.index = skip++ + 1;
            });
            this.total = res.total;
            this.loading = false;
            /**无数据返回上一页 */
            if (this.searchPagin.currentPage > 1) {
                if (this.tableData.length == 0) {
                    this.searchPagin.currentPage = this.searchPagin.currentPage - 1;
                    this.$refs.pagination.handleCurrentChange(this.searchPagin.currentPage);
                }
            }
        } catch (error) {
            this.loading = false;
        }
    }

    public sort(col): void {
        if (col.order == 'ascending') {
            this.searchValue.asc = true;
        } else {
            this.searchValue.asc = false;
        }
        switch (col.prop) {
            case 'shipperContactName':
                {
                    this.searchValue.orderBy = 1;
                }
                break;
            case 'shipperContactPhone':
                {
                    this.searchValue.orderBy = 2;
                }
                break;
            case 'isEnabled':
                {
                    this.searchValue.orderBy = 3;
                }
                break;
            case 'creationTime':
                {
                    this.searchValue.orderBy = 4;
                }
                break;
        }
        this.loadData();
    }

    public datetimerange(v) {
        if (v) {
            this.searchValue.startTime = v[0];
            this.searchValue.endTime = v[1];
        } else {
            this.searchValue.startTime = null;
            this.searchValue.endTime = null;
        }
    }
    public resetSearchValue() {
        this.searchValue = {
           customerBaseName: '',
            customerBaseContactName:'',
            isEnabled: null,
            startTime: '',
            endTime: '',
            asc: null,
            orderBy: ''
        };
         this.searchFunc();
    }

    public handleClose() {
        this.dialogVisible = false;
    }
    public async updateReset() {
        this.selectReset = false;
    }

    public SelectAddress = {
        province: {
            value: '',
            text: '',
        },
        city: {
            value: '',
            text: '',
        },
        area: {
            value: '',
            text: '',
        },
    };
    public async getProvince(item, name) {
        this.formData.province = item;
        // this.formData.province = name;
    }

    public async getCityCode(item, name) {
        this.formData.city = item;
    }

    public async getAreaCode(item, name) {
        this.formData.county = item;
    }
    async querySearch(queryString, cb) {
       try {
            let res = await CustomerBase.GetDropDownList({ name: this.searchValue.customerBaseName,isEditPermission:true,isEnabled:false});
            let result = [];
            res.forEach((dd) => {
                let xx = {
                    value: dd.customerBaseName,
                    id: dd.id,
                };
                result.push(xx);
            });
            cb(result); 
       } catch (error) {
          
       }
    }
    selecShip(data) {
        this.searchValue.customerBaseName = data.value;
    }
    shipperTypeChange(e){
        if(e==1){
            this.formData.rainClothAmount = 50;
            this.formData.customerBaseCode = '';
        }else{
            this.formData.customerBaseCode = '';
            this.formData.rainClothAmount = 0;
        }
        
    }
    public save() {
        this.$refs.formData.validate(async (valid) => {
            if (valid) {
                console.log(this.formData);
                 this.formData.carrierRelations = [];
                 this.formData.carrierRelationsList.forEach((item) => {
                    let res = this.carrierList.filter((v) => v.id == item)[0];
                    this.formData.carrierRelations.push({
                        relationId: '',
                        carrierName: res.name,
                        carrierId: res.id,
                    });
                });
                if(this.title == '新增客户/基地'){
                    let formData =Object.assign({},this.formData);
                    delete formData.carrierRelationsList;
                    CustomerBase.Add(formData).then(res=>{
                        this.$message.success('新增成功!');
                        this.loadData();
                        this.dialogVisible = false;
                    })
                }else{
                    let formData =Object.assign({},this.formData);
                    delete formData.carrierRelationsList;
                    CustomerBase.Edit(this.formData.id,formData).then(res=>{
                        this.$message.success('编辑成功!');
                        this.loadData();
                        this.dialogVisible = false;
                    })
                }
                
            }
        });
    }



   async addbtn() {
        this.title = '新增客户/基地';
            this.formData = {
            customerBaseName: '',
            customerBaseType: null,
            customerBaseCode: '',
            customerBaseContactName: '',
            customerBaseContactPhone: '',
            province: '',
            city: '',
            county: '',
            detail: '',
            carrierRelationsList: [],
            carrierRelations: [],
            rainClothAmount: '',
            isEnabled: true,
            remark: '',
        };
        if (this.$refs.formData) {
            this.$refs.formData.resetFields();
            this.$refs.address.clear();
        }
        let res = await Carrier.GetList({ enabled:true,count: -1 });
        this.carrierList = res.data;
        this.dialogVisible = true;
    }

    async toEdit(id:string) {
        this.title = '编辑客户/基地';
        this.selectReset = false;
        let data:any = await CustomerBase.GetDetail(id);
        data.carrierRelationsList = data.carrierRelations.map(v=>{return v.carrierId});
        this.SelectAddress.province.value = data.province;
        this.SelectAddress.city.value = data.city;
        this.SelectAddress.area.value = data.county;
         this.formData = {
            id:data.id,
            customerBaseName: data.customerBaseName,
            customerBaseType: data.customerBaseType,
            customerBaseCode: data.customerBaseCode,
            customerBaseContactName: data.customerBaseContactName,
            customerBaseContactPhone: data.customerBaseContactPhone,
            province: data.province,
            city: data.city,
            county: data.county,
            detail: data.detail,
            carrierRelationsList: data.carrierRelationsList,
            carrierRelations: data.carrierRelations,
            rainClothAmount: data.rainClothAmount,
            isEnabled: data.isEnabled,
            remark: data.remark,
        };
        this.selectReset = true;
        if (this.$refs.formData) {
            this.$refs.formData.resetFields();
            this.$refs.address.clear();
        }
        let res = await Carrier.GetList({enabled:true, count: -1 });
        this.carrierList = res.data;
        this.dialogVisible = true;
    }
    public dialogConfig = {
        title: '',
        show: false,
    };
    confirmClose() {
        this.dialogConfig = {
            title: '',
            show: false,
        };
    }
    confirmOk() {
        CustomerBase.Delete(this.id).then((res) => {
            this.$message.success('删除成功');
            this.loadData();
        });
        this.dialogConfig = {
            title: '',
            show: false,
        };
    }

    public id:string = '';

    toDel(id) {
        this.id = id;
        this.dialogConfig = {
            title: '删除',
            show: true,
        };
    }
    handleInput(e, index) {
        e.target.value =  e.target.value=e.target.value.replace(/[^\d]/g,'');
        this.formData.customerBaseContactPhone = e.target.value;
    }
}
